/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_P_Mcp_TitleInputs */

const en_cad_agents_p_mcp_title = /** @type {(inputs: Cad_Agents_P_Mcp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP server`)
};

/**
* | output |
* | --- |
* | "MCP server" |
*
* @param {Cad_Agents_P_Mcp_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_p_mcp_title = /** @type {((inputs?: Cad_Agents_P_Mcp_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_P_Mcp_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_p_mcp_title(inputs)
});
export { cad_agents_p_mcp_title as "cad.agents.p_mcp_title" }